module.exports = __webpack_public_path__ + "img/airplane-1.ed44aee2.jpg";